import React, { useState } from 'react';

import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import CardMedia from '@mui/material/CardMedia';
import Card from '@mui/material/Card';
import Box from '@mui/material/Box';

import { CardActionArea, useTheme } from '@mui/material';

import { VisibilityRounded } from '@mui/icons-material';

import { useWidth } from '../../config/withSelector';

const styles = {
  cardOnHover: {
    width: '100%',
    //height: '240px',
    position: 'absolute',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'rgba(255,255,255,0.4)',
    flexDirection: 'column',
    cursor: 'pointer',
  },
};

export default function MapCard(props) {
  const { map, handleNavigate } = props;
  const theme = useTheme();
  const [onMouseEnter, setOnMouseEnter] = useState(false);

  const breakpoint = useWidth();

  return (
    <Card
      variant="outlined"
      sx={{
        maxHeight: 'auto',
        boxShadow: 'none',
        borderWidth: 'thin',
        borderColor: theme.palette.gray.mediumLight,
        position: 'relative',
      }}
      onClick={handleNavigate(map.id)}
      onMouseEnter={() => {
        setOnMouseEnter(map.id);
      }}
      onMouseLeave={() => {
        setOnMouseEnter(null);
      }}
    >
      <CardActionArea />

      {onMouseEnter === map.id && (
        <Box sx={[styles.cardOnHover, { height: breakpoint === 'xl' ? '240px' : '140px' }]}>
          <VisibilityRounded
            sx={{
              height: 30,
              width: 30,
              color: theme.palette.blues.dark,
            }}
          />
          <Typography
            sx={{
              fontWeight: '600',
              color: theme.palette.blues.dark,
              fontSize: '14px',
            }}
          >
            View project
          </Typography>
        </Box>
      )}

      <CardMedia
        component="img"
        alt="map-preview"
        height={breakpoint === 'xl' ? '240' : '140'}
        image={map.mapPreview}
      />

      <CardContent
        sx={{
          minHeight: '5rem',
          height: '5rem',
          background: theme.palette.gray.superLight,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          '&:hover': {
            background: theme.palette.gray.light,
          },
        }}
      >
        <Typography
          gutterBottom
          variant="body2"
          component="div"
          align="center"
          sx={{
            color: theme.palette.gray.main,
            fontWeight: '600',
            cursor: 'pointer',
            fontSize: '1rem',
          }}
        >
          {map.mapTitle}
        </Typography>
      </CardContent>
    </Card>
  );
}
